
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-date-pickers/adapters-locale",
      function () {
        return require("private-next-pages/x/react-date-pickers/adapters-locale.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-date-pickers/adapters-locale"])
      });
    }
  